<template>
  <basic-portlet title="New Relic Graphs">
    <div class="row">
      <div class="col-12 mb-4">
        <h5>Errors</h5>
        <iframe src="https://chart-embed.service.eu.newrelic.com/herald/cc56fac3-2812-4634-b5f0-628f71192d32?height=400px&timepicker=true" width="100%"
                height="400" frameborder="no" />
      </div>
      <div class="col-12 mb-4">
        <h5>Throughput (request per minute)</h5>
        <iframe src="https://chart-embed.service.eu.newrelic.com/herald/6416e57f-bf71-41e0-a672-881af33b956a" width="100%"
                height="400" frameborder="no" />
      </div>
      <div class="col-12 mb-4">
        <h5>Top 5 Slowest Web Transactions</h5>
        <iframe src="https://chart-embed.service.eu.newrelic.com/herald/b375a68f-e1b7-4209-bee2-8cf732a618d8" width="100%"
                height="300" frameborder="no" />
      </div>
    </div>
  </basic-portlet>
</template>
<script>
import BasicPortlet from "VueComponents/BasicPortlet";
export default {
  components: { BasicPortlet },
};
</script>
